import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { resources as AlumniProfiles } from "./AlumniProfiles";
import { resources as AlumniEvents } from "./AlumniEvents";

import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <BusinessCenterIcon />,
  name: "Алумни",
  title: "Алумни",
  subMenu: [AlumniProfiles, AlumniEvents],
};
